import BASE64 from 'crypto-js/enc-base64';
import HMACSHA256 from 'crypto-js/hmac-sha256';
import { isMobile } from 'react-device-detect';
import { IGenericObject } from 'models/global';


interface IUrlArray {
  fonts: Array<IGenericObject>;
  url: string;
}

export const convertToQspString = (params: any) => {
  let result = '';
  for (const key in params) {
    const value = params[key];
    if (typeof value  !== 'undefined') {
      const encodedValue = fixedEncodeUriComponent(String( value ));
      result += `${key}=${encodedValue}&`;
    }
  }
  return result.slice(0, -1);
};

export const createHash = (qsp: string, secret: string) => {
  const hash = HMACSHA256(qsp, secret);
  return BASE64.stringify(hash);
};

export const debounce = (func: any, wait: any, immediate?: any) => {
  let timeout: NodeJS.Timeout;

  return function executedFunction() {
    let context: any;
    const args = arguments;

    const later = function() {
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};

export const fixedEncodeUriComponent = (str: string) => {
  return encodeURIComponent(str)
    .replace(/[!'()]/g, escape)
    .replace(/\*/g, '%2A');
};

export const getQueryParamByName = (name: string, url: string) => {
  const regexS = '[\\?&#]' + name + '=([^&#]*)';
  const regex = new RegExp(regexS);

  const results = regex.exec( url || window.location.search ) ||
    regex.exec( window.location.hash );

  if ( results === null ) { return ''; }
  return decodeURIComponent( results[ 1 ].replace( /\+/g, ' ' ) );
};

const isArray = function (a: any) {
  return Array.isArray(a);
};

const isObject = function (o: any) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function';
};

const copyObject = ( data: any ) => {
  return isObject( data ) || isArray( data ) ? JSON.parse( JSON.stringify( data ) ): data;
}

const toCamel = (s: any) => {
  return s.replace(/([-_][a-z])/ig, ($1: any) => {
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '');
  });
};

export const normalizeStyles = function (rawStyles: any, topLevel?:boolean) {

  const o = topLevel === false? rawStyles: copyObject(rawStyles);

  if (isObject(o)) {
    const n: {[key: string]: any} = {};

    Object.keys(o)
      .forEach((k) => {
        if (k === 'background_image' || k === 'backgroundImage') {
          o[k] = o[k] && `url(${o[k]})`
        }

        if (k === 'hover' && !isMobile) {
          const key = ':hover';
          o[key] = o[k];
          k = key;
        }

        if (k === 'active') {
          const key = ':active';
          o[key] = o[k];
          k = key;
        }

        if(o[k] !== '' && o[k] !== null && o[k] !== undefined) {
          n[toCamel(k)] = normalizeStyles(o[k], false);
        }

      });

    return n;
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return normalizeStyles(i, false);
    });
  }

  return o;
};

export const isTrue = (value: any) => {
  return [true, 1, 'true', 'enabled', 'yes'].indexOf(value) > -1;
}

export const wrapCSSUrl = ( url: string ) => {
  url = url.trim();

  if( url.substring( 0, 4 ) !== 'url(' ) {
    url = `url('${url}')`;
  }

  return url;
};

export const insertFonts = (urlArray: Array<IUrlArray>) => {
  if (!urlArray) {
    return;
  }

  urlArray.forEach(fontObj => {
    const isFontAlreadyLoaded = document.head.querySelector(`link[href="${fontObj.url}"`);
    if (isFontAlreadyLoaded) {
      return;
    }
    
    const fontLink = document.createElement('link');
    document.head.appendChild(fontLink);
    fontLink.rel = 'stylesheet';
    fontLink.href = fontObj.url;
  });
};

export const convertRegExp = (string: string) => {
  if (!string || typeof string === 'object') return '';

  var regParts = string.match(/^\/(.*?)\/([gim]*)$/);
  if (regParts) {
      // the parsed pattern had delimiters and modifiers. handle them.
      return new RegExp(regParts[1], regParts[2]);
  } else {
      // we got pattern string without delimiters
      return new RegExp(string);
  }
};